import { render, staticRenderFns } from "./delivery-statistic.vue?vue&type=template&id=498059ca&scoped=true"
import script from "./delivery-statistic.vue?vue&type=script&lang=js"
export * from "./delivery-statistic.vue?vue&type=script&lang=js"
import style0 from "./delivery-statistic.vue?vue&type=style&index=0&id=498059ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498059ca",
  null
  
)

export default component.exports